import React from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './featureItem.module.css';

function FeatureItem(data){
    return (
        <div className={styles.featureItem}>
            <div className={styles.itemIcon}>
                <img src={data.item.itemicon.image.asset.url} alt={data.item.itemicon.image.alt} />
            </div>
            <div className={styles.itemText}>
                <h4>{data.item.itemlabel}</h4>
                <PortableText blocks={data.item.itemdesc} />
            </div>
        </div>
    );
}
    
export default FeatureItem;